import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const ShoeIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M17.5 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" />
    <path
      fillRule="evenodd"
      d="M18 9a4 4 0 0 0-1.4-3c-.8-.9-2-1.3-3.4-1a7.4 7.4 0 0 0-3.7 2.8 8 8 0 0 0-1.3 6.4c.3 1.3.6 2.7 1.1 4a9 9 0 0 0 1.7 3c.7.8 2 1 3 1s2.3-.6 3-1.6c.5-.7.4-1.5.3-2.1a11 11 0 0 0-.6-1.8 12 12 0 0 1-.6-1.7v-1.2l.7-1.3.4-.7c.4-.7.8-1.7.8-2.8Zm-4.2-2c.5-.2 1 0 1.5.4.4.4.7 1 .7 1.6 0 .6-.2 1.2-.6 1.9l-.3.4-.9 1.9a4 4 0 0 0 0 2.2l.6 2 .6 1.5v.5c-.3.5-.9.7-1.5.8-.7 0-1.3-.2-1.5-.4-.3-.3-.8-1.2-1.2-2.3-.4-1.2-.8-2.5-1-3.7a6 6 0 0 1 .9-4.9c.8-1.1 2-1.7 2.7-2Z"
      clipRule="evenodd"
    />
    <path d="M11 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM8 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM7 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm6-5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" />
  </Icon>
));
export default ShoeIcon;
